import { Radio, RadioGroup } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { PlanoCard } from './plano-card';
import { BoxDismissIcon } from '../../../../../components/icons';
import Button from '../../../../../components/button';
import { AddCircle } from '@material-ui/icons';
import { useState } from 'react';
import { findAllPlanoVizi } from '../../../../../services/vizi-planos';
import { FIND_WHITE_LABEL } from '../../../../../graphql/queryes';
import { useQuery } from 'react-apollo';

export const PlanoList = ({
  handleDadosCadastrais,
  dadosCadastrais,
  onClose,
}) => {
  const [planos, setPlanos] = useState([]);
  const [loading, setLoading] = useState(false);

  const { data, loading:loadingWhiteLabel } = useQuery(FIND_WHITE_LABEL)
  const whitelabel = data?.findEntidadeLogada?.whitelabel?.nome

  const getPlanos = async (variables) => {
    try {
      setLoading(true);
      const response = await findAllPlanoVizi(variables,whitelabel);
      setPlanos(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const history = useHistory();
  const clickCard = (plano) => {
    handleDadosCadastrais(plano, 'plano');
  };
  const goPlanosWhitelabel = () => {
    onClose();
    history.push('planos-whitelabel');
  };
  useEffect(() => {
    getPlanos({
      titulo: '',
    });
  }, []);
  return (
    <>
      <Subtitle>Escolha um plano:</Subtitle>
      <RadioGroup style={{ gap: '10px' }}>
        {loading && <Subtitle> Carregando... </Subtitle>}
        {!loading && planos?.length === 0 && (
          <EmptyListContainer>
            <EmptyListIconContainer>
              <BoxDismissIcon />
            </EmptyListIconContainer>
            <p>Nenhum plano foi criado</p>
            <Button onClick={goPlanosWhitelabel}>
              Criar plano
              <AddCircle />
            </Button>
          </EmptyListContainer>
        )}
        {planos?.map((plano, key) => (
          <Row key={plano.id} onClick={() => clickCard(plano)}>
            <Radio
              checked={plano.id === dadosCadastrais?.plano?.id}
              color="primary"
            />
            <PlanoCard {...plano}></PlanoCard>
          </Row>
        ))}
      </RadioGroup>
    </>
  );
};
const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;
const Subtitle = styled.h1`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 14px;
`;
const EmptyListContainer = styled.div`
  display: grid;
  min-width: 100%;
  place-content: center;
  place-items: center;
  background-color: #fff;
  border-radius: 10px;
  padding-block: 32px;
  p {
    font-size: 24px;
  }
`;

const EmptyListIconContainer = styled.div`
  svg {
    font-size: 64px;
  }
`;
